export interface PrepareCallResponse {
  twilio_token: {
    type: string
    token: string
  }
  call_id: string
}

export interface VoiceCallDto {
  id: string
  conversation_id: string
  workspace_id: string
  date_created: string
  date_modified: string
  status: VoiceCallStatusDto
  caller_user_public_id: string
  recipient_user_public_id: string | null
  twilio_call_sid: string | null
  date_connecting: string | null
  date_ringing: string | null
  date_started: string | null
  date_completed: string | null
  date_recording_ready: string | null
  recording_url: string | null
  completed_call_duration: number | null
}

export enum VoiceCallStatusDto {
  Prepared = 'PREPARED',
  Connecting = 'CONNECTING',
  Ringing = 'RINGING',
  InProgress = 'IN_PROGRESS',
  Completed = 'COMPLETED',
}

export type VoiceCallEventsDto =
  | VoiceCallPreparedEvent
  | VoiceCallConnectingEvent
  | VoiceCallRingingEvent
  | VoiceCallAnsweredEvent
  | VoiceCallCompletedEvent
  | VoiceCallRecordingReadyEvent

/**
 * Voice Call Real Time Events
 */

export interface VoiceCallPreparedEvent {
  type: 'VOICE_CALL_PREPARED'
  payload: {
    id: string
    date_prepared: string
    caller_user_public_id: string
    recipient_user_public_id: string
    conversation_id: string
    workspace_id: string
  }
}

export interface VoiceCallConnectingEvent {
  type: 'VOICE_CALL_CONNECTING'
  payload: {
    id: string
    date_connecting: string
    caller_user_public_id: string
    recipient_user_public_id: string
    twilio_call_sid: string
    conversation_id: string
    workspace_id: string
  }
}

export interface VoiceCallRingingEvent {
  type: 'VOICE_CALL_RINGING'
  payload: {
    id: string
    date_ringing: string
    twilio_call_sid: string
    conversation_id: string
  }
}

export interface VoiceCallAnsweredEvent {
  type: 'VOICE_CALL_ANSWERED'
  payload: {
    id: string
    date_answered: string
    twilio_call_sid: string
    conversation_id: string
  }
}

export interface VoiceCallCompletedEvent {
  type: 'VOICE_CALL_COMPLETED'
  payload: {
    id: string
    date_completed: string
    twilio_call_sid: string
    conversation_id: string
    workspace_id: string
    duration: number
  }
}

export interface VoiceCallRecordingReadyEvent {
  type: 'VOICE_CALL_RECORDING_READY'
  payload: {
    id: string
    date_recording_ready: string
    recording_url: string
    workspace_id: string
    conversation_id: string
  }
}
